export default __webpack_public_path__ + "static/media/b54.79d03d54.png";